import { useModulePermission } from '../../../hooks/usePermission';

/**
 * D202 模組權限 hook
 *
 * 基於 pgCode = "pwd202f1"（SYS_Program 中的繳庫單程式代碼）
 * 權限格式: pwd202f1_QUERY, pwd202f1_ADD, pwd202f1_EDIT, pwd202f1_DELETE, pwd202f1_EXPORT, pwd202f1_PRINT, pwd202f1_APPROVE
 */
export function useD202Permission() {
  return useModulePermission('pwd202f1');
}
